import { render } from "./GruposGestão.vue?vue&type=template&id=45237f62&scoped=true"
import script from "./GruposGestão.vue?vue&type=script&lang=js"
export * from "./GruposGestão.vue?vue&type=script&lang=js"

import "./GruposGestão.vue?vue&type=style&index=0&id=45237f62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45237f62"]])

export default __exports__